import {
  ratingChipClass,
  ratingLabel,
  type ManufacturerRatingKind,
  type ManufacturerRatingValue,
} from '@/lib/manufacturer-ratings'
import { cn } from '@/lib/utils'

/**
 * One rating value as a colored chip. `inherited` marks a value set on a parent category: same
 * color, dashed outline.
 */
export function ManufacturerRatingBadge<K extends ManufacturerRatingKind>({
  rating,
  value,
  inherited = false,
  className,
  children,
}: {
  rating: K
  value: ManufacturerRatingValue[K]
  inherited?: boolean
  className?: string
  children?: React.ReactNode
}) {
  return (
    <span
      className={cn(
        'inline-flex max-w-full items-center gap-1 whitespace-nowrap',
        ratingChipClass(rating, value, inherited),
        className,
      )}
    >
      {children ?? ratingLabel(rating, value)}
    </span>
  )
}
